export default "__VITE_ASSET__D7vCzOg5__"